import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {DialogData_ConfirmationDialog, DialogData_ConfirmationDialogOutput} from "../confirmation-dialog/confirmation-dialog.component";

export interface DialogData_ReplaceDialog extends MatDialogDataBaseInput {
	title: string;
	description: string;
	okText: string;
	cancelText: string;
	replaceAllText: string;
}

export interface DialogData_ReplaceDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-replacing-dialog",
	templateUrl: "./replacing-dialog.component.html",
	styleUrls: ["./replacing-dialog.component.scss"],
	standalone: false,
})
export class ReplacingDialogComponent extends BasicMaterialDialog<
	ReplacingDialogComponent,
	DialogData_ReplaceDialog,
	DialogData_ReplaceDialogOutput
> {
	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}
}
